/**
 * Dynamically injects a CSS stylesheet link into the document head.
 * Used when this module is loaded as a remote via Module Federation.
 *
 * Returns a Promise that resolves once the <link> has finished loading,
 * so callers can gate first paint on the stylesheet being applied and
 * avoid a flash of unstyled content.
 */
export function injectStylesheet(href: string): Promise<void> {
    const id = 'admin-module-styles';
    const existing = document.getElementById(id) as HTMLLinkElement | null;

    if (existing) {
        return new Promise((resolve) => {
            if (existing.sheet) {
                resolve();
                return;
            }
            existing.addEventListener('load', () => resolve(), { once: true });
            existing.addEventListener('error', () => resolve(), { once: true });
        });
    }

    return new Promise((resolve) => {
        const link = document.createElement('link');
        link.id = id;
        link.rel = 'stylesheet';
        link.href = href;
        link.addEventListener('load', () => resolve(), { once: true });
        link.addEventListener('error', () => resolve(), { once: true });
        document.head.appendChild(link);
    });
}
